import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FaBone, FaPaw } from 'react-icons/fa';
import css from './LoadingPage.module.css';

const LoadingPage = () => {
  return (
    <div className={css.root}>
      <div className={css.loaderWrapper}>
        <div className={css.trailWrapper}>
          <FaPaw className={`${css.paw} ${css.paw1}`} />
          <FaPaw className={`${css.paw} ${css.paw2}`} />
          <FaPaw className={`${css.paw} ${css.paw3}`} />
          <FaPaw className={`${css.paw} ${css.paw4}`} />
          <FaBone className={css.bone} />
        </div>
      </div>
      <div className={css.message}>
        <FormattedMessage
          id="LoadingPage.message"
          defaultMessage="Fetching your pet’s spot... Sit. Stay. Relax."
        />
      </div>
    </div>
  );
};

export default LoadingPage;
